export const chooseBookCompetition = (
  competitions = [],
  preferredCompetition = '',
  preferredSport = 'SOCCER',
) => {
  if (!competitions.length) return null;

  const competitionCode = String(preferredCompetition || '').toUpperCase();
  const sportCode = String(preferredSport || 'SOCCER').toUpperCase();
  return competitions.find((competition) => (
    String(competition.short_name || '').toUpperCase() === competitionCode
  )) || competitions.find((competition) => (
    String(competition.sport || '').toUpperCase() === sportCode
  )) || competitions.find((competition) => (
    String(competition.sport || '').toUpperCase() === 'SOCCER'
  )) || competitions[0];
};

// Yarışma kodları iki sağlayıcıda çakışabilir; filtre ve sayaç anahtarında
// kaynak da taşınır. Katalog satırı ``short_name``, olay satırı
// ``competition`` alanını kullanır.
export const bookCompetitionId = (row = {}) => {
  const code = row.short_name || row.competition || '';
  return code ? `${row.feed || 'sportsbook'}:${code}` : '';
};

export const filterBookEvents = (
  events = [],
  { sport = '', competition = '', feed = '', query = '' } = {},
) => {
  const wantedSport = String(sport || '').toUpperCase();
  const wantedCompetition = String(competition || '').toLowerCase();
  const wantedFeed = String(feed || '').toLowerCase();
  const needle = String(query || '').trim().toLowerCase();

  return events.filter((event) => {
    if (wantedCompetition) {
      if (String(event.competition || '').toLowerCase() !== wantedCompetition) return false;
      if (wantedFeed && String(event.feed || 'sportsbook').toLowerCase() !== wantedFeed) return false;
    } else if (wantedSport && String(event.sport || '').toUpperCase() !== wantedSport) {
      return false;
    }
    if (!needle) return true;
    return `${event.home || ''} ${event.away || ''} ${event.name || ''} ${event.competition_name || ''}`
      .toLowerCase().includes(needle);
  });
};

export const countBookEvents = (events = []) => {
  const sports = {};
  const competitions = {};
  events.forEach((event) => {
    const sport = event.sport || 'OTHER';
    const competition = bookCompetitionId(event);
    sports[sport] = (sports[sport] || 0) + 1;
    if (competition) competitions[competition] = (competitions[competition] || 0) + 1;
  });
  return {
    total: events.length,
    sports,
    competitions,
    activeCompetitions: Object.keys(competitions).length,
  };
};
